import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import Hero from '../components/Hero';
import ClientLogos from '../components/ClientLogos';
import ServicesOverview from '../components/ServicesOverview';
import HowItWorks from '../components/HowItWorks';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import CTABanner from '../components/CTABanner';
import AppShowcase from '../components/AppShowcase';
import ProductsSection from '../components/ProductsSection';
import ServiceAreas from '../components/ServiceAreas';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <ServiceAreas />
        <ServicesOverview />
        <ProductsSection />
        <AppShowcase />
        <HowItWorks />
        <WhyChooseUs />
        <CTABanner />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Homepage;
